import type { TFunction } from "i18next"

import type { PaymentMethodNameEnum } from "@/enums"

export const getPaymentMethod = (
  paymentMethod: PaymentMethodNameEnum | undefined,
  t: TFunction
): string => {
  if (!paymentMethod) return "-"
  return t(`common.paymentMethods.${paymentMethod}`)
}
